(function () {
  function reveal(e) {
    var card = e.target.closest && e.target.closest('grid-item');
    if (!card) return;
    card.querySelectorAll('template[data-hover-image-deferred]').forEach(function (t) {
      t.replaceWith(t.content.cloneNode(true));
    });
  }
  document.addEventListener('pointerover', reveal, { passive: true });
  document.addEventListener('touchstart', reveal, { passive: true });
  document.addEventListener('focusin', reveal);
})();
